import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ResponseApi } from "../features/common/interface/responseApi";

@Injectable({
  providedIn: 'root'
})
export class ToLegalService {

  ApiUrl = environment.API_URL;

  constructor(private http: HttpClient) {}

  verificarAdesaoToLegal(codigoCadastro: string): Observable<any>{ 
    return this.http.get<ResponseApi>(`${this.ApiUrl}/campanha/sorteio/validarSorteioAdesao/${codigoCadastro}`);
  }

  getListaSorteio(searchParams: any): Observable<any>{
    const params = this.setParams(searchParams);
    return this.http.get<ResponseApi>(`${this.ApiUrl}/campanha/sorteio/listarSorteios/cadastro`, { params });
  }

  getCuponsDeUmSorteio(searchParams) {
    const params = this.setParams(searchParams);
    return this.http.get<ResponseApi>(`${this.ApiUrl}/campanha/sorteio/listarCupons`, { params });
  }

  setParams(searchParams) {
    let params = new HttpParams();
    if (!searchParams) {
      return params;
    }
    if (searchParams.key && searchParams.value) {
      return params.set(searchParams.key, searchParams.value);
    }
    for (const key of Object.keys(searchParams)) {
      params = params.set(key, searchParams[key]);
    }
    return params;
  }


}